import type { CodeEditorLanguage } from "@v1/components/modals/CodeEditorModal";

import * as React from "react";

import DeprecatedButton from "@v1/components/designSystem/button/Button";
import { useModal } from "@v2/store/modalStore";

export const CodeEditorCustomPropModifier = (props: {
  value: string | null;
  onChange: (value: string) => void;
  language: CodeEditorLanguage;
}) => {
  const { openModal } = useModal();
  const { language, value, onChange } = props;

  return (
    <DeprecatedButton
      variant="secondary"
      layoutClassName="w-full"
      onClick={() => {
        return openModal({
          type: "codeEditorModal",
          props: {
            language,
            value,
            onChange,
          },
        });
      }}
    >
      Launch Code Editor
    </DeprecatedButton>
  );
};
